import React from 'react'

import { Checkbox } from '@driftt/dds'

enum RequiredAttributesEnum {
  PHONE_NUMBER = 'PHONE_NUMBER',
  NAME = 'NAME',
}

interface RequiredGuestAttributesProps {
  attributes: string[]
  updateRequiredAttributesState: (attributes: string[]) => void
  disabled: boolean
}

const RequiredGuestAttributes = ({
  attributes,
  updateRequiredAttributesState,
  disabled,
}: RequiredGuestAttributesProps) => {
  const updateRequiredAttributes = (
    attributeName: string,
    isChecked: boolean
  ) => {
    if (isChecked) {
      if (attributes) {
        attributes.push(attributeName)
        updateRequiredAttributesState(attributes)
      } else {
        updateRequiredAttributesState([attributeName])
      }
    } else {
      const newValues = attributes.filter((i) => i !== attributeName)
      updateRequiredAttributesState(newValues)
    }
  }

  return (
    <>
      <Checkbox
        label="Require guest name"
        checked={attributes?.some(
          (attr) => attr === RequiredAttributesEnum.NAME
        )}
        onChange={(val) => {
          updateRequiredAttributes(RequiredAttributesEnum.NAME, val)
        }}
        disabled={disabled}
      />
      <Checkbox
        label="Require guest phone number"
        checked={attributes?.some(
          (attr) => attr === RequiredAttributesEnum.PHONE_NUMBER
        )}
        onChange={(val) => {
          updateRequiredAttributes(RequiredAttributesEnum.PHONE_NUMBER, val)
        }}
        disabled={disabled}
      />
    </>
  )
}

export default RequiredGuestAttributes
